var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"job_listing"}},[_c('div',{staticClass:"header"},[_c('JobListingHeader')],1),_c('div',{staticClass:"body my-10"},[_c('ListingTHead'),_c('ListingTBody')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }